var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, EyeOffIcon, EyeOnIcon, Pane, Paragraph, Table, Tooltip, } from 'evergreen-ui';
import mapboxgl from 'mapbox-gl';
import { useCallback, useContext, useEffect, useMemo, useRef, useState, } from 'react';
import { Accordion, AccordionItem, AccordionItemButton, AccordionItemHeading, AccordionItemPanel, } from 'react-accessible-accordion';
import { LocationContext } from '../contexts/LocationContext';
import { MapContext } from '../contexts/MapContext';
import { MarkerContext } from '../contexts/MarkerContext';
import { TaskRefContext } from '../contexts/TaskRefContext';
import addMarker from '../utility/addMarker';
import Pin from './Pin';
import TableSortHeader from './TableSortHeader';
import TableSpacer from './TableSpacer';
import { TaskEditContext } from '../contexts/TaskEditContext';
import { UserContext } from '../contexts/UserContext';
import { useLocation } from '../hooks/useLocation';
import { usePlan } from '../hooks/usePlan';
import PaginatedTable from './PaginatedTable';
var TasksTable = function (_a) {
    var _b, _c;
    var tasks = _a.tasks, extended = _a.extended, deleteMode = _a.deleteMode, selectedDate = _a.selectedDate, isExpandedView = _a.isExpandedView, editMode = _a.editMode;
    var plan = usePlan();
    var apothekeLocations = useLocation();
    var _d = useContext(MapContext), map = _d.map, isMapLoaded = _d.isMapLoaded;
    var mapRef = map[0], setMapRef = map[1];
    var mapLoaded = isMapLoaded[0];
    var refs = useContext(TaskRefContext).refs;
    var _e = useState(true), loading = _e[0], setLoading = _e[1];
    var setTaskRefs = refs[1];
    var setEditTasks = useContext(TaskEditContext).setTasks;
    var paginatedRefs = useRef();
    //CreateTaskRefs
    var itemsRef = useRef([]);
    //Show pins on map
    var _f = useState(false), showPins = _f[0], setShowPins = _f[1];
    var markerContext = useContext(MarkerContext).markers;
    var markers = markerContext[0], setMarkers = markerContext[1];
    var locations = useContext(LocationContext).availableLocations;
    var _g = useState(''), search = _g[0], setSearch = _g[1];
    var _h = useState(''), addressSearch = _h[0], setAddressSearch = _h[1];
    var _j = useState(null), sortNamesBy = _j[0], setSortNamesBy = _j[1]; // null | asc | desc
    var _k = useState(null), apoFilter = _k[0], setApoFilter = _k[1]; // Apos to include in results
    var _l = useState([
        'unassigned',
        'prepared',
        'assigned',
        'ontheway',
        'declined',
        'attached',
        'successfull',
        'optimizing',
        'error',
        'pickedup',
    ]), stateFilter = _l[0], setStateFilter = _l[1]; // States to include in results
    var _m = useState([]), tagFilter = _m[0], setTagFilter = _m[1];
    var _o = useState(''), timeStart = _o[0], setTimeStart = _o[1];
    var _p = useState(''), timeEnd = _p[0], setTimeEnd = _p[1];
    var user = useContext(UserContext).user;
    var isUser = user[0];
    useEffect(function () {
        if (tagFilter === null && isUser.tags !== null) {
            setTagFilter(isUser.tags);
        }
    }, [isUser, tagFilter]);
    var removeAllMarkers = function () {
        markers.map(function (marker) {
            marker.remove();
        });
    };
    var showAllMarkers = function () {
        var markerArray = [];
        var bounds = new mapboxgl.LngLatBounds();
        tasks.map(function (task) {
            var marker = addMarker(mapRef, task.task_coords, null, task.task_type, 2, _jsx(Pin, { task: task, activity: { type: task.task_type } }));
            bounds.extend([task.task_coords[0], task.task_coords[1]]);
            markerArray.push(marker);
        });
        try {
            mapRef.current.fitBounds(bounds, { padding: 50 });
        }
        catch (error) {
            console.log(error);
        }
        setMarkers(markerArray);
    };
    var setPinPreferences = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setShowPins(!showPins);
            if (showPins) {
                localStorage.setItem('showPins', 'false');
                removeAllMarkers();
            }
            else {
                localStorage.setItem('showPins', 'true');
            }
            return [2 /*return*/];
        });
    }); };
    var selectAllShownTasks = function () {
        var tasks = paginatedRefs.current.getAllRefs();
        console.log(tasks);
        tasks.current.map(function (t) { return t.selectTask(); });
        var ids = tasks.current.map(function (t) { return t.getId(); });
        setEditTasks(ids);
    };
    var deSelectAllShownTasks = function () {
        var tasks = paginatedRefs.current.getAllRefs();
        tasks.current.map(function (t) { return t.deselectTask(); });
        setEditTasks([]);
    };
    var checkPinPreferences = function () { return __awaiter(void 0, void 0, void 0, function () {
        var state;
        return __generator(this, function (_a) {
            state = localStorage.getItem('showPins');
            if (state === 'true') {
                showAllMarkers();
                setShowPins(true);
            }
            if (state === 'false') {
                setShowPins(false);
                removeAllMarkers();
            }
            if (state === null) {
                localStorage.setItem('showPins', 'false');
                setShowPins(false);
            }
            return [2 /*return*/];
        });
    }); };
    useEffect(function () {
        if (mapLoaded)
            checkPinPreferences();
    }, [mapLoaded, tasks, showPins]);
    var sortForNames = useCallback(function (tasks) {
        return tasks.sort(function (aTask, bTask) {
            var a = aTask.customer_name.split(' ');
            var b = bTask.customer_name.split(' ');
            var aSur = a[a.length - 1];
            var bSur = b[b.length - 1];
            switch (sortNamesBy) {
                case null: {
                    return bTask.task_created.seconds - aTask.task_created.seconds;
                }
                case 'asc': {
                    return aSur.localeCompare(bSur);
                }
                case 'desc': {
                    return bSur.localeCompare(aSur);
                }
                default: {
                    return 0;
                }
            }
        });
    }, [sortNamesBy]);
    var openTasks = useMemo(function () {
        return sortForNames(tasks.filter(function (_a) {
            var task_status = _a.task_status, isMerged = _a.isMerged, gls = _a.gls;
            return (task_status === 'unassigned' || task_status === 'prepared') &&
                !isMerged &&
                !gls;
        }));
    }, [sortForNames, tasks]);
    useEffect(function () {
        itemsRef.current = itemsRef.current.slice(0, openTasks.length);
    }, [openTasks]);
    var progressTasks = useMemo(function () {
        return sortForNames(tasks.filter(function (_a) {
            var task_status = _a.task_status, gls = _a.gls;
            return (task_status === 'assigned' ||
                task_status === 'ontheway' ||
                task_status === 'declined' ||
                task_status === 'optimizing' ||
                task_status === 'error' ||
                task_status === 'pickedup' ||
                task_status === 'attached') &&
                !gls;
        }));
    }, [sortForNames, tasks]);
    var doneTasks = useMemo(function () {
        return sortForNames(tasks.filter(function (_a) {
            var task_status = _a.task_status, gls = _a.gls;
            return (task_status === 'successfull' || task_status === 'successful') &&
                !gls;
        }));
    }, [sortForNames, tasks]);
    var glsTasks = useMemo(function () { return sortForNames(tasks.filter(function (task) { return task.gls; })); }, [sortForNames, tasks]);
    // Select all apos on liad
    useEffect(function () {
        if (apoFilter === null) {
            if (locations && locations[0] && locations[0].length !== 0) {
                setApoFilter(locations.map(function (loc) { return loc.id; }));
            }
        }
    }, [apoFilter, locations]);
    useEffect(function () {
        if (openTasks && progressTasks && doneTasks && glsTasks && tasks) {
            setLoading(false);
        }
    }, [doneTasks, glsTasks, openTasks, progressTasks, tasks]);
    return (_jsxs(_Fragment, { children: [_jsxs(Table.Head, __assign({ style: {
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'flex-start',
                    height: 'fit-content',
                    paddingTop: 12,
                    paddingBottom: 6,
                    backgroundColor: 'transparent',
                    position: 'relative',
                } }, { children: [_jsx(TableSortHeader, { searchPlaceholder: 'Suche nach Name, Auftragsnummer, ...', search: true, searchState: search, onSearchValueChange: setSearch, sort: true, sortState: sortNamesBy, onSortSet: setSortNamesBy, filter: true, filterTitle: 'Nach Tags filtern', filterOptions: (_c = (_b = isUser === null || isUser === void 0 ? void 0 : isUser.tags) === null || _b === void 0 ? void 0 : _b.map(function (t) {
                            return { label: t, value: t };
                        })) !== null && _c !== void 0 ? _c : [], filterState: tagFilter, onFilterChanged: setTagFilter, filterResetBehavior: 'none', extended: extended, marginBottom: 10, marginTop: -10, marginLeft: 10 }), _jsxs("div", __assign({ style: {
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: '100%',
                        } }, { children: [_jsx(TableSortHeader, { title: 'Status', filter: true, filterTitle: 'Nach Status filtern', filterOptions: [
                                    {
                                        label: 'Nicht zugeteilt',
                                        value: 'unassigned',
                                    },
                                    {
                                        label: 'Zugeteilt',
                                        value: 'assigned',
                                    },
                                    {
                                        label: 'Vorbereitet',
                                        value: 'prepared',
                                    },
                                    {
                                        label: 'Angehangen',
                                        value: 'attached',
                                    },
                                    {
                                        label: 'Eingesammelt',
                                        value: 'pickedup',
                                    },
                                    {
                                        label: 'Auf dem Weg',
                                        value: 'ontheway',
                                    },
                                    {
                                        label: 'Nicht angetroffen',
                                        value: 'declined',
                                    },
                                    {
                                        label: 'Erfolgreich',
                                        value: 'successfull',
                                    },
                                    {
                                        label: 'In Optimierung',
                                        value: 'optimizing',
                                    },
                                    {
                                        label: 'Fehlerhaft',
                                        value: 'error',
                                    },
                                ], filterState: stateFilter, onFilterChanged: setStateFilter, filterResetBehavior: 'all' }), _jsx("div", __assign({ style: {
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    gap: 10,
                                    maxWidth: '60%',
                                } }, { children: (extended || isExpandedView) && (_jsxs(_Fragment, { children: [_jsx(TableSortHeader, { title: 'Adresse', searchPlaceholder: 'Nach Adresse filtern...', search: true, searchState: addressSearch, onSearchValueChange: setAddressSearch, extended: extended, marginBottom: 0 }), _jsx(TableSortHeader, { title: 'Apotheke', filter: true, filterTitle: 'Nach Apotheke filtern', filterSearch: true, filterOptions: locations.map(function (loc) {
                                                return { label: loc.name, value: loc.id };
                                            }), filterState: apoFilter, onFilterChanged: setApoFilter, filterResetBehavior: 'all' }), _jsx(TableSortHeader, { title: 'Zeitfenster', timespanFilter: true, timeStart: timeStart, timeEnd: timeEnd, onTimeStartChange: setTimeStart, onTimeEndChange: setTimeEnd })] })) })), _jsx(Tooltip, __assign({ content: "Entscheide ob du alle Auftr\u00E4ge auf der Karte sehen m\u00F6chtest!" }, { children: !showPins ? (_jsx(EyeOffIcon, { onClick: setPinPreferences, style: {
                                        cursor: 'pointer',
                                        position: 'relative',
                                        right: 26,
                                        bottom: 2,
                                    } })) : (_jsx(EyeOnIcon, { onClick: setPinPreferences, style: {
                                        cursor: 'pointer',
                                        position: 'relative',
                                        right: 26,
                                        bottom: 2,
                                    } })) }))] }))] })), _jsxs(Pane, __assign({ style: { width: '100%', flex: 1, overflow: 'scroll' } }, { children: [_jsxs(Accordion, __assign({ preExpanded: ['OPEN'], allowMultipleExpanded: "true", allowZeroExpanded: "true" }, { children: [_jsxs(AccordionItem, __assign({ uuid: 'OPEN' }, { children: [_jsx(AccordionItemHeading, { children: _jsx(AccordionItemButton, { children: _jsx(TableSpacer, { state: true, title: "".concat(openTasks.length, " offene Auftr\u00E4ge") }) }) }), _jsxs(AccordionItemPanel, { children: [editMode && (_jsxs(_Fragment, { children: [_jsx(Button, __assign({ onClick: function () { return selectAllShownTasks(); }, margin: 4 }, { children: "Alle anw\u00E4hlen" })), _jsx(Button, __assign({ onClick: function () { return deSelectAllShownTasks(); }, margin: 4 }, { children: "Alle abw\u00E4hlen" }))] })), _jsx(PaginatedTable, { itemsRef: itemsRef, ref: paginatedRefs, data: openTasks, editMode: editMode, isExpandedView: isExpandedView, selectedDate: selectedDate, plan: plan, locations: apothekeLocations, search: search, stateFilter: stateFilter, timeStart: timeStart, timeEnd: timeEnd, addressSearch: addressSearch, tagFilter: tagFilter, apoFilter: apoFilter })] }), openTasks.length === 0 && !loading && (_jsx(AccordionItemPanel, { children: _jsx(Paragraph, __assign({ textAlign: "center" }, { children: "Keine offenen Auftr\u00E4ge" })) }))] })), _jsxs(AccordionItem, __assign({ uuid: 'PROGRESS' }, { children: [_jsx(AccordionItemHeading, { children: _jsx(AccordionItemButton, { children: _jsx(TableSpacer, { color: "#D3F5F7", title: "".concat(progressTasks.length, " Auftr\u00E4ge in Bearbeitung") }) }) }), _jsx(AccordionItemPanel, { children: _jsx(PaginatedTable, { data: progressTasks, editMode: editMode, isExpandedView: isExpandedView, selectedDate: selectedDate, plan: plan, locations: apothekeLocations, search: search, stateFilter: stateFilter, timeStart: timeStart, timeEnd: timeEnd, addressSearch: addressSearch, tagFilter: tagFilter, apoFilter: apoFilter }) }), openTasks.length === 0 && !loading && (_jsx(AccordionItemPanel, { children: _jsx(Paragraph, __assign({ textAlign: "center" }, { children: "Keine offenen Auftr\u00E4ge" })) }))] })), isUser.glsContactId && (_jsxs(AccordionItem, __assign({ uuid: 'GLS' }, { children: [_jsx(AccordionItemHeading, { children: _jsx(AccordionItemButton, { children: _jsx(TableSpacer, { color: "#F5F5D3", title: "".concat(glsTasks.length, " GLS Auftr\u00E4ge") }) }) }), _jsx(AccordionItemPanel, { children: _jsx(PaginatedTable, { data: glsTasks, editMode: editMode, isExpandedView: isExpandedView, selectedDate: selectedDate, plan: plan, locations: apothekeLocations, search: search, stateFilter: stateFilter, timeStart: timeStart, timeEnd: timeEnd, addressSearch: addressSearch, tagFilter: tagFilter, apoFilter: apoFilter }) })] }))), _jsxs(AccordionItem, __assign({ uuid: 'DONE' }, { children: [_jsx(AccordionItemHeading, { children: _jsx(AccordionItemButton, { children: _jsx(TableSpacer, { color: "#E1F4DD", title: "".concat(doneTasks.length, " erledigte Auftr\u00E4ge") }) }) }), _jsx(AccordionItemPanel, { children: _jsx(PaginatedTable, { data: doneTasks, editMode: editMode, isExpandedView: isExpandedView, selectedDate: selectedDate, plan: plan, locations: apothekeLocations, search: search, stateFilter: stateFilter, timeStart: timeStart, timeEnd: timeEnd, addressSearch: addressSearch, tagFilter: tagFilter, apoFilter: apoFilter }) }), doneTasks.length === 0 && !loading && (_jsx(AccordionItemPanel, { children: _jsx(Paragraph, __assign({ fontVariant: "contextual", textAlign: "center" }, { children: "Keine erledigten Auftr\u00E4ge" })) }))] }))] })), tasks.length === 0 && (_jsx(Paragraph, __assign({ className: "bodytext", style: { textAlign: 'center', margin: 20 } }, { children: "An diesem Datum sind noch keine Auftr\u00E4ge" })))] }))] }));
};
export default TasksTable;
